import classNames from 'classnames';
import { _ as _defineProperty } from './defineProperty-18999f8e.js';
import createUseStyles from './create/index.js';
import { CenterAlignedContentWidth, CenterAlignedContentMargins, BreakPoints } from './enums/index.js';
import { isOS, mediaQuery } from './helpers/index.js';
import { j as jsxRuntime } from './jsx-runtime-0f8a08a2.js';

var _root;
var useStyles = createUseStyles({
  root: (_root = {
    width: '100%',
    maxWidth: "".concat(CenterAlignedContentWidth.ExtraLarge, "px"),
    margin: '0 auto'
  }, _defineProperty(_root, isOS(), {
    paddingLeft: 'env(safe-area-inset-left)',
    paddingRight: 'env(safe-area-inset-right)'
  }), _defineProperty(_root, mediaQuery(BreakPoints.ExtraLarge), {
    maxWidth: "".concat(CenterAlignedContentWidth.Adaptive),
    padding: "0 ".concat(CenterAlignedContentMargins.Large, "px")
  }), _defineProperty(_root, mediaQuery(BreakPoints.Large), {
    padding: "0 ".concat(CenterAlignedContentMargins.Medium, "px")
  }), _defineProperty(_root, mediaQuery(BreakPoints.Medium), {
    padding: "0 ".concat(CenterAlignedContentMargins.Small, "px")
  }), _root)
}, {
  name: 'centered-content'
});

function CenteredContent(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var _useStyles = useStyles(),
      root = _useStyles.root;

  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: classNames(root, className),
    children: children
  });
}

export { CenteredContent as C };
//# sourceMappingURL=CenteredContent-bc317fd4.js.map
